<template>
  <div id="attendContent">
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>活动管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主体内容 -->
    <div class="content">
      <!-- 搜索框 -->
      <el-form inline label-position="right" label-width="80px" class="query-form">
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick">查询</el-button>
          <el-button type="success" @click="addClick()">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表框 -->
      <el-card class="box-card table">
        <template #header>
          <span>活动列表</span>
        </template>
        <el-tabs v-model="query.state" @tab-click="selClick">
          <el-tab-pane v-for="item in stateList" :label="item.label" :name="item.value.toString()" :key="item.value">
          </el-tab-pane>
        </el-tabs>
        <!-- 列表表格 -->
        <el-table v-loading="loading" :data="tableData" ref="table" border stripe style="width: 100%"
          table-layout="auto" @sort-change="sortChange">
          <el-table-column prop="title" label="活动名称"></el-table-column>
          <el-table-column prop="typeName" label="活动状态"></el-table-column>
          <el-table-column prop="startTime" label="活动举办时间"></el-table-column>
          <el-table-column label="活动地区">
            <template #default="scope">
              {{ scope.row.province
              }}{{ scope.row.city ? "/" + scope.row.city : ""
              }}{{ scope.row.district ? "/" + scope.row.district : "" }}
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序号"></el-table-column>
          <el-table-column prop="isEnable" label="是否启用">
            <template #default="scope">
              <el-tag type="success" v-if="scope.row.isEnable">是</el-tag>
              <el-tag type="warning" v-else>否</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button type="primary" size="mini" icon="el-icon-edit" @click="editClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button type="warning" size="mini" icon="el-icon-delete" @click="delClick(scope.row)"></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 新增/编辑对话框 -->

    <el-dialog :title="form.id > 0 ? '编辑活动' : '添加活动'" :visible.sync="dialogVisible" :close-on-click-modal="false"
      width="800px" @opened="
        dialogOpened();
      dialogOpened2();
      ">
      <el-form :model="form" ref="form" label-width="100px" @submit.native.prevent="submitForm">
        <el-tabs type="card">
          <el-tab-pane label="基础信息">
            <el-form-item label="活动名称" prop="title" :rules="[{ required: true, message: '请输入活动名称' }]">
              <el-input v-model="form.title" placeholder="请输入活动名称"></el-input>
            </el-form-item>
            <el-form-item label="活动摘要" prop="summary">
              <el-input v-model="form.summary" placeholder="请输入活动摘要"></el-input>
            </el-form-item>
            <el-form-item label="活动状态">
              <el-select v-model="form.activityType" placeholder="由时间自动计算" disabled style="width: 100%">
                <el-option v-for="state in stateList.filter((s) => s.value !== 0)" :key="state.value"
                  :label="state.label" :value="state.value">
                </el-option>
              </el-select>
              <div class="form-tip">根据活动开始/结束、报名截止时间自动更新（约每分钟）</div>
            </el-form-item>
            <el-form-item label="活动开始时间" prop="startTime">
              <el-date-picker v-model="form.startTime" type="datetime" placeholder="选择活动开始时间" format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="活动结束时间" prop="endTime">
              <el-date-picker v-model="form.endTime" type="datetime" placeholder="选择活动结束时间" format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm">
              </el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="活动结束时间" prop="acEnd" :rules="[
                { required: true, message: '请选择活动结束时间' }
              ]">
                <el-date-picker v-model="form.acEnd" type="datetime" placeholder="选择活动结束时间" format="YYYY-MM-DD HH:mm"
                  value-format="YYYY-MM-DD HH:mm">
                </el-date-picker>
              </el-form-item> -->

            <el-form-item label="报名开始时间" prop="signupStart">
              <el-date-picker v-model="form.signupStart" type="datetime" placeholder="选择报名开始时间"
                format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="报名截止时间" prop="signupEnd">
              <el-date-picker v-model="form.signupEnd" type="datetime" placeholder="选择报名截止时间" format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="活动地区" prop="formRegion">
              <el-cascader v-model="formRegion" :options="regionOptions" placeholder="请选择省/市/区" clearable filterable
                :props="{
                  value: 'value',
                  label: 'label',
                  children: 'children',
                }">
              </el-cascader>
            </el-form-item>

            <el-form-item label="活动地点" prop="address">
              <el-input v-model="form.address" placeholder="请输入详细活动地点"></el-input>
            </el-form-item>
            <el-row :gutter="24">
              <el-col :span="9">
                <!-- :rules="[{ required: true, message: '不能为空' }]" -->
                <el-form-item label="经度" prop="longitude">
                  <el-input v-model="form.longitude" placeholder="请选择坐标" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="纬度" prop="latitude">
                  <el-input v-model="form.latitude" placeholder="请选择坐标" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-button type="success" @click="dialogMap = true">选择位置</el-button>
              </el-col>
            </el-row>
            <el-form-item label="总人数上限" prop="maxSignup">
              <el-input v-model.number="form.maxSignup" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="已报名人数" prop="signupCount" :rules="[{ required: true, message: '不可为空' }]">
              <el-input v-model.number="form.signupCount" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="排序号" prop="sort" :rules="[{ required: true, message: '不可为空' }]">
              <el-input v-model.number="form.sort" placeholder="请输入排序号，数字越大越靠前"></el-input>
            </el-form-item>
            <el-form-item label="浏览量" prop="viewCount" :rules="[{ required: true, message: '不可为空' }]">
              <el-input v-model.number="form.viewCount" placeholder="请输入浏览量"></el-input>
            </el-form-item>

            <el-form-item label="是否启用">
              <el-switch v-model="form.isEnable" active-text="启用" inactive-text="禁用"></el-switch>
            </el-form-item>
            <el-form-item label="是否需注册用户">
              <el-switch v-model="form.needRegister" active-text="启用" inactive-text="禁用"></el-switch>
            </el-form-item>
          </el-tab-pane>

          <el-tab-pane label="活动详情">
            <el-form-item label="列表卡片封面" prop="coverImg" :rules="[{ required: true, message: '不可为空' }]">
              <div id="uploadBtnCov" class="uploader uploader-warning"></div>
              <img :src="domain + form.coverImg.imgSmall" style="height: 40px; margin-left: 10px"
                v-if="form.coverImg" />
            </el-form-item>
            <el-form-item label="活动详情" prop="content">
              <div style="position: relative;z-index:1000;">
                <vue-ueditor-wrap v-model="form.content" :config="editorConfig"></vue-ueditor-wrap>
              </div>
            </el-form-item>
            <el-form-item label="活动回顾图">
              <el-alert type="warning" :closable="true" title="建议上传 3:4 竖图（与小程序回顾页展示一致，更新更方便）" show-icon>
              </el-alert>
              <br />
              <div id="minImageBtnConfig" class="uploader uploader-warning"></div>
              <el-row>
                <el-col v-for="(item, index) in imgList" :key="index" style="padding: 5px" :span="6">
                  <el-card :body-style="{ padding: '0px' }">
                    <el-image class="upload-demo" :src="domain + item.imgSmall" fit="cover"
                      style="width: 100%; height: 200px" :preview-src-list="[domain + item.imgBig]">
                    </el-image>
                    <div style="margin-left: 9px;margin-bottom: 20px;">
                      <el-button-group>
                        <el-tooltip content="前移" placement="top">
                          <el-button size="small" @click="moveclick(index)" type="primary"
                            icon="arrow-left">前移</el-button>
                        </el-tooltip>
                        <el-tooltip content="删除" placement="top">
                          <el-button size="small" @click="deleteclick(index)" type="danger" icon="delete">删除</el-button>
                        </el-tooltip>
                      </el-button-group>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
              <div style="height: 20px"></div>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 地图选择对话框 -->
    <el-dialog title="拖动位置标记设置坐标" :visible.sync="dialogMap" @opened="dialogMapOpen()" width="800px">
      <el-form label-width="90px" @submit.native.prevent="searchMap()">
        <el-form-item label="搜索地址">
          <el-input v-model="searchKey" placeholder="请输入省市区街道门牌号" clearable @keyup.enter.native="searchMap()">
            <el-button type="primary" slot="append" icon="el-icon-search" @click="searchMap()">搜索</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <div style="padding-bottom:10px;">
        <span style="color:rgb(254, 209, 81);">*搜索关键词带上省市区街道门牌号码</span>
        坐标：{{ latLng.lng }},{{ latLng.lat }}
      </div>
      <div id="mapContainer" style="height: 500px"></div>

      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="yesClickMap">确定</el-button>
        <el-button @click="dialogMap = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import amapHelper from "@/plugins/amapHelper.js";
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  name: "Attend",
  components: { VueUeditorWrap },
  data() {
    return {
      domain: url.getDomain(),
      rules: {},
      // 活动状态列表，统一管理状态信息
      stateList: [
        { value: 0, label: "全部状态" },
        { value: 1, label: "报名中" },
        { value: 2, label: "已结束" },
        { value: 3, label: "进行中" },
      ],
      query: {
        key: "",
        state: 0,
        province: "",
        sort: "",
        order: "",
      },
      regionValue: "",
      regionOptions: [],
      getDomain: url.getDomain(),
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {},
      formRegion: [],
      dialogVisible: false,
      submiting: false,
      uploader: null,
      editorConfig: {
        serverUrl: url.getUE(),
        UEDITOR_HOME_URL: url.getUEConfig(),
        initialFrameWidth: "100%",
        initialFrameHeight: 500,
      },
      imgList: [],

      dialogMap: false, //地图-对话框
      latLng: {}, // 当前坐标
      searchKey: "", //地图-搜索词
      map: null, // 地图实例
      marker: null, // 标记实例
      geocoder: null, // 地理编码实例
      originalAddress: "", // 打开地图对话框时的原地址

      // 添加报名弹窗相关
      addJoinDialogVisible: false,
      addJoinForm: {
        enterIds: [], // 选中的会员ID列表
      },
      currentActivityId: null, // 当前活动ID
      currentActivityName: "", // 当前活动名称
      enterlist: [], // 会员列表
      memberLoading: false, // 加载状态
      submitJoinLoading: false, // 提交加载状态
      selectedMembers: [], // 已选择的会员详情
    };
  },
  methods: {
    api(a) {
      return url.getActivity(a);
    },
    addClick() {
      this.dialogVisible = true;
      this.form = {
        isEnable: true,
        sort: 0,
        state: 1,
        viewCount: 0,
        signupCount: 0,
      };
      this.formRegion = [];
      this.imgList = [];
    },

    // 根据状态值获取状态标签
    getStateLabel(stateValue) {
      const state = this.stateList.find((item) => item.value === stateValue);
      return state ? state.label : "";
    },

    // 根据状态值获取标签类型
    getStateType(stateValue) {
      const state = this.stateList.find((item) => item.value === stateValue);
      return state ? state.type : "";
    },

    GetArea() {
      var link = url.getActivity("GetAreaThree");
      $.get(link, {}, (res) => {
        this.regionOptions = res;
      });
    },
    // 查询
    selClick() {
      this.currentPage = 1;
      this.getList();
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },

    // 排序
    sortChange(sortColumn) {
      this.query.sort = sortColumn.prop;
      this.query.order = sortColumn.order === "ascending" ? "asc" : "desc";
      this.getList();
    },

    // 获取列表数据
    // getList() {
    //   this.loading = true;
    //   const params = {
    //     ...this.query,
    //     pageSize: this.pageSize,
    //     pageIndex: this.currentPage
    //   };
    //   if(this.regionValue.length > 0){
    //     params.district = this.regionValue[2]
    //   }
    //   const apiUrl = url.getActivity("GetListAct");
    //   $.get(apiUrl, params, (data) => {
    //     this.loading = false;
    //     this.tableData = data.list || [];
    //     this.total = data.total || 0;
    //   }).fail(() => {
    //     this.loading = false;
    //     this.$message.error('网络错误，获取数据失败');
    //   });
    // },
    getList() {
      this.loading = true;
      $.get(
        this.api("GetListAct"),
        {
          key: this.query.key,
          type: this.query.state,
          pageindex: this.currentPage,
          pagesize: this.pageSize,
        },
        (data) => {
          this.loading = false;
          this.tableData = data.list;
          this.total = data.total;
        },
      );
    },
    // 编辑
    editClick(row) {
      this.form = Object.assign({}, row);
      this.formRegion = [];
      console.log(this.imgList);
      if (this.form.province) this.formRegion.push(this.form.province);
      if (this.form.city) this.formRegion.push(this.form.city);
      if (this.form.district) this.formRegion.push(this.form.district);
      if (this.form.coverImg) {
        this.form.coverImg = JSON.parse(this.form.coverImg);
      }
      this.imgList = this.form.imgList ? JSON.parse(this.form.imgList) : [];
      this.dialogVisible = true;
    },

    // 删除
    // delClick(row) {
    //   this.$confirm('确定要删除该活动吗？', '确认删除', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     const apiUrl = url.getActivity("DeleteAct");
    //     $.post(apiUrl, { id: row.id }, (data) => {
    //       if (data && data.status) {
    //         this.$message.success('删除成功');
    //         this.getList();
    //       } else {
    //         this.$message.error(data?.msg || '删除失败');
    //       }
    //     }).fail(() => {
    //       this.$message.error('网络错误，删除失败');
    //     });
    //   }).catch(() => {
    //     this.$message.info('已取消删除');
    //   });
    // },
    delClick(row) {
      this.$confirm("确定删除？", "提示", { type: "warning" })
        .then(() => {
          $.post(this.api("DeleteAct"), { id: row.id }, (res) => {
            if (res.status) {
              this.getList();
              this.$message.success(res.msg);
            } else this.$message.error(res.msg);
          });
        })
        .catch(() => { });
    },
    // 对话框打开时初始化上传组件
    // dialogOpened() {
    // const _this = this;
    // // 先销毁已存在的上传实例
    // if (this.uploader) {
    //   this.uploader.destroy();
    // }
    // // 初始化上传组件
    // this.uploader = $("#uploadBtn1").uploader({
    //   url: url.getUpload(),
    //   text: "上传图片",
    //   fileExts: "jpg;png",
    //   type: "fixedcut",
    //   maxSize: 1024 * 1024 * 1, // 1MB限制
    //   subfolder: "active", // 上传到active子目录
    //   more: true, // 允许多文件上传
    //   auto: true, // 自动上传
    //   isImg: true, // 图片类型
    //   debug:true,
    //   maxWidth: 200,
    //   maxHeight: 200,
    //   onSuccess: function (data) {
    //     // 上传成功后保存相对路径
    //     _this.form.image = data.relativeName;
    //     _this.$message.success('图片上传成功');
    //   },
    //   onError: function (err) {
    //     _this.$message.error('上传失败: ' + (err.msg || '未知错误'));
    //   }
    // });

    // },
    // 上传图片
    dialogOpened() {
      var _this = this;
      /**大小图片前台处理，后台简单处理模式，上传成功后显示图片**/
      $("#uploadBtnCov").uploader({
        url: url.getUpload(),
        fileExts: "jpg;png;jpeg",
        text: "选择图片",
        more: true, //是否可以上传多个
        auto: true, //是否自动上传
        // type: "imgdouble",
        type: "cutdouble",
        minWidth: 400,
        minHeight: 320,
        maxWidth: 1360,
        maxHeight: 1088,
        handleType: "0", //对于大小图模式最好不要自动处理
        subfolder: "content", //默认后台处理简单模式 ，指定子文件夹
        onSuccess: function (data) {
          //添加到列表,每个图片上传成功都会触发
          console.log(data);

          var obj = {
            imgSmall: data.small.relativeName,
            imgBig: data.big.relativeName,
          };
          _this.form.coverImg = obj;
          console.log(_this.form.coverImg,_this.form.coverImg.imgSmall);
          
        },
      });
    },
    dialogOpened2() {
      var _this = this;
      if ($("#minImageBtnConfig input").length <= 0) {
        $("#minImageBtnConfig").uploader({
          url: url.getUpload(),
          fileExts: "jpg;png;jpeg",
          text: "选择图片",
          more: true,
          auto: true,
          type: "imgdouble",
          minWidth: 800,
          minHeight: 800,
          maxWidth: 2000,
          maxHeight: 2000,
          handleType: "0",
          subfolder: "content",
          onSuccess: function (data) {
            var obj = {
              imgSmall: data.small.relativeName,
              imgBig: data.big.relativeName,
            };
            _this.imgList.push(obj);
          },
        });
      }
    },
    moveclick(index) {
      if (index == 0) {
        // this.imgString.length-1
        var a = this.imgList[index];
        this.imgList[index] = this.imgList[this.imgList.length - 1];
        this.imgList[this.imgList.length - 1] = a;
        this.getList();
      } else {
        var a = this.imgList[index];
        this.imgList[index] = this.imgList[index - 1];
        this.imgList[index - 1] = a;
        this.getList();
      }
    },
    deleteclick(index) {
      this.imgList.splice(index, 1);
    },

    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.submiting = true;
        const formData = this.form;
        formData.province = this.formRegion[0];
        formData.city = this.formRegion[1];
        formData.district = this.formRegion[2];
        
        if(formData.coverImg){
          formData.coverImg = JSON.stringify(formData.coverImg);
        }else{
          return this.$message.error('请上传列表卡片封面');
        }

        formData.imgList = JSON.stringify(this.imgList);

        $.post(this.api("EditAct"), formData, (res) => {
          this.submiting = false;
          if (res.status) {
            this.dialogVisible = false;
            this.getList();
            this.$message.success(res.msg);
          } else this.$message.error(res.msg);
        });
      });
    },
    /**======================================【地图】====================== */
    //地图框显示
    dialogMapOpen: function () {
      var _this = this;
      // 保存原地址，避免丢失
      _this.originalAddress = _this.form.address || "";

      if (_this.form.address)
        _this.searchKey =
          _this.formRegion[0] +
          _this.formRegion[1] +
          _this.formRegion[2] +
          _this.form.address;

      // 选择坐标处理
      var marker;
      var init = function () {
        var map = new AMap.Map("mapContainer", {
          zoom: 13,
          resizeEnable: true,
        });
        var center = map.getCenter();
        _this.latLng = center;

        //处理搜索逻辑
        _this.map = map;

        // 如果有坐标，直接定位
        if (_this.form.latitude) {
          center = new AMap.LngLat(
            parseFloat(_this.form.longitude),
            parseFloat(_this.form.latitude),
          );
          _this.latLng = center;
          map.setCenter(center);
        }
        // 如果没有坐标但有地址，自动搜索定位（但不更新地址）
        else if (_this.searchKey) {
          setTimeout(() => {
            _this.searchMap(true); // true表示自动搜索，只定位不更新地址
          }, 500);
        }

        // 创建点标记
        var marker = new AMap.Marker({
          position: center,
          content:
            '<img src="//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png" width="28" height="34" />',
          offset: new AMap.Pixel(-13, -30),
          draggable: true,
        });
        map.add(marker);

        //展示当前选择的坐标
        marker.on("dragend", function (e) {
          var lnglat = e.lnglat;
          _this.latLng = lnglat;
          // 拖动结束后获取地址信息
          _this.getAddressInfo(lnglat);
        });
        _this.marker = marker;
        _this.geocoder = new AMap.Geocoder({
          city: "全国", //城市设为北京，默认：全国
        });
      };
      init();
    },

    // 获取地址信息
    async getAddressInfo(lnglat) {
      const _this = this;
      // 保存原地址
      var oldAddress = _this.form.address || _this.originalAddress || "";
      try {
        const result = await amapHelper.regeocode(lnglat.lng, lnglat.lat);

        if (result.success && result.data && result.data.formatted_address) {
          // 更新地址信息
          _this.form.address = result.data.formatted_address;
        } else {
          // 如果获取失败，保留原地址
          if (oldAddress) {
            _this.form.address = oldAddress;
          }
        }
      } catch (error) {
        console.error("获取地址信息失败:", error);
        // 如果获取失败，保留原地址
        if (oldAddress) {
          _this.form.address = oldAddress;
        }
      }
    },

    //确定按钮
    async yesClickMap() {
      var _this = this;

      // 保存原地址
      var oldAddress = _this.form.address || _this.originalAddress || "";

      // 更新坐标
      _this.form.latitude = _this.latLng.lat;
      _this.form.longitude = _this.latLng.lng;

      // 如果地址为空，通过坐标获取地址
      if (!_this.form.address) {
        try {
          const result = await amapHelper.regeocode(
            _this.latLng.lng,
            _this.latLng.lat,
          );
          if (result.success && result.data && result.data.formatted_address) {
            _this.form.address = result.data.formatted_address;
          }
        } catch (error) {
          console.error("获取地址信息失败:", error);
        }
      }
      // 如果地址存在，保留原地址
      else if (oldAddress) {
        _this.form.address = oldAddress;
      }

      _this.dialogMap = false;
    },

    //搜索按钮
    // isAuto: true表示自动搜索（打开地图时），只定位不更新地址；false表示用户主动搜索，更新地址
    async searchMap(isAuto) {
      var _this = this;

      if (!_this.searchKey.trim()) {
        if (!isAuto) {
          _this.$message.warning("请输入搜索关键词");
        }
        return;
      }

      try {
        // 使用高德API进行地理编码
        const result = await amapHelper.geocode(_this.searchKey, "");

        if (result.success) {
          const data = result.data;

          // 更新坐标
          _this.latLng = {
            lng: parseFloat(data.longitude),
            lat: parseFloat(data.latitude),
          };

          // 更新表单坐标
          _this.form.longitude = data.longitude;
          _this.form.latitude = data.latitude;

          // 只有用户主动搜索时才更新地址
          if (!isAuto) {
            _this.form.address = data.formatted_address;
          }
          // 自动搜索时，如果原地址存在，保留原地址
          else if (_this.originalAddress) {
            _this.form.address = _this.originalAddress;
          }

          // 移动地图到新位置
          if (_this.map && _this.marker) {
            const newLocation = new AMap.LngLat(
              _this.latLng.lng,
              _this.latLng.lat,
            );
            _this.map.setCenter(newLocation);
            _this.marker.setPosition(newLocation);
          }

          if (!isAuto) {
            _this.$message.success("地址解析成功");
          }
        } else {
          if (!isAuto) {
            _this.$message.error(result.message || "未找到相关地址");
          }
        }
      } catch (error) {
        console.error("搜索失败:", error);
        if (!isAuto) {
          _this.$message.error("搜索失败，请稍后重试");
        }
      }
    },
  },
  created() {
    this.getList();
    this.GetArea();
    //   this.Getallenter();
  },
  // beforeUnmount() {
  //   // 组件销毁时清理上传实例
  //   if (this.uploader) {
  //     this.uploader.destroy();
  //   }
  // }
};
</script>

<style scoped>
.content {
  margin-top: 20px;
}

.query-form {
  margin-bottom: 20px;
}

.table {
  width: 100%;
}

.el-button+.el-button {
  margin-left: 10px;
}

.image-preview {
  margin-top: 10px;
}

::v-deep .el-cascader {
  width: 100%;
}

::v-deep .el-upload-list {
  margin-top: 10px;
}

.form-tip {
  margin-top: 4px;
  color: #999;
  font-size: 12px;
  line-height: 1.4;
}
</style>
